import React from 'react';
const FAQ_ITEMS = [{
  question: 'What is this UX guide?',
  answer: 'This is a short A\u2013Z guide explaining common UX, brand and marketing terms in plain English. It is designed to make project meetings clearer and more productive.'
}, {
  question: 'Who is this guide for?',
  answer: 'It\u2019s for founders, marketing leads and anyone involved in brand, website or digital projects who wants clearer conversations and better outcomes.'
}, {
  question: 'What does UX mean?',
  answer: 'UX stands for user experience. It refers to how people interact with a product, website or service and how that experience feels overall.'
}];
export function FaqSection() {
  return <section style={{
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
    paddingTop: '4rem',
    borderTop: '1px solid #E5E5E0'
  }} data-id="element-36">
      <h2 style={{
      fontSize: 'clamp(1.5rem, 3.5vw, 1.875rem)',
      lineHeight: '1.2'
    }} data-id="element-37">
        Frequently Asked Questions
      </h2>

      <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '2.5rem'
    }} data-id="element-38">
        {FAQ_ITEMS.map((item, idx) => <div key={idx} style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem'
      }} data-id="element-39">
            <h3 style={{
          fontSize: '1.125rem',
          fontWeight: 600,
          lineHeight: '1.3'
        }} data-id="element-40">
              {item.question}
            </h3>
            <p style={{
          fontSize: '1.125rem',
          lineHeight: '1.7'
        }} data-id="element-41">
              {item.answer}
            </p>
          </div>)}
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: FAQ_ITEMS.map(item => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer
          }
        }))
      })
    }} data-id="element-42" />
    </section>;
}